import React, { ReactElement } from 'react';
import classNames from 'classnames/bind';
// (!) New user registration disabled (by the https://searate.atlassian.net/browse/IMPACT-2774)
// import Link from 'next/link';
import styles from 'sections/Company/CodeOfEthics/components/SectionHeader/SectionHeader.module.scss';

const cn = classNames.bind(styles);

const SectionHeader = (): ReactElement => {
  return (
    <section className={cn('header')}>
      <div className={cn('container')}>

        <div className={cn('header__content')}>
          <h1 className={cn('header__heading')}>
            Code of Ethics
          </h1>

          <div className={cn('header__description')}>
            <p className={cn('header__paragraph')}>
              The Digital Freight Alliance fully adheres to these business
              ethics and standards regarding dealings with other our members.
            </p>
          </div>

          {/* (!) New user registration disabled (by the https://searate.atlassian.net/browse/IMPACT-2774) */}
          {/* <div className={cn('header__buttons')}>
            <Link
              className={cn('header__button-join')}
              href='/membership'
            >
              Join Us
            </Link>
          </div> */}
        </div>

        <div className={cn('header__image-container')}>
          <picture>
            <source
              srcSet="/images/pages/Company/CodeOfEthics/scales@2x.webp 2x, 
                      /images/pages/Company/CodeOfEthics/scales.webp 1x"
              sizes="100vw"
            />
            <img
              className={cn('header__image')}
              src="/images/pages/Company/CodeOfEthics/scales.webp"
              alt="code of ethics"
            />
          </picture>
        </div>

      </div>
    </section>
  );
};

export default SectionHeader;